import { cn } from "@/lib/utils"

interface CardBodyContentProps {
  testId?: string
}

type CardProps = React.HTMLAttributes<HTMLDivElement> & { ref?: React.Ref<HTMLDivElement> }
export const Card = ({ className, ...props }: CardProps) => (
  <div className={cn("border-border bg-surface box-border h-fit rounded-xl border", className)} {...props} />
)

export const CardHeader = ({ className, ...props }: CardProps) => (
  <div className={cn("flex items-center justify-between gap-2 self-stretch p-2 pl-4", className)} {...props} />
)

type CardHeaderProps = React.HTMLAttributes<HTMLHeadingElement> & { ref?: React.Ref<HTMLHeadingElement> }
export const CardHeaderTitle = ({ className, ...props }: CardHeaderProps) => (
  <h3 className={cn("text-on-surface text-base font-medium", className)} {...props} />
)

type CardMetaProps = React.HTMLAttributes<HTMLParagraphElement> & { ref?: React.Ref<HTMLParagraphElement> }
export const CardMeta = ({ className, ...props }: CardMetaProps) => (
  <div
    className={cn("text-on-surface-subdued text-xs leading-4 font-normal tracking-[0.25px]", className)}
    {...props}
  />
)

export const CardBody = ({ className, ...props }: CardProps) => <div className={className} {...props} />

export const CardBodyHeader = ({ className, ...props }: CardProps) => (
  <div
    className={cn(
      `text-on-surface-subdued flex items-start justify-between border-t p-0 py-1 text-sm leading-5 font-medium`,
      className,
    )}
    {...props}
  />
)

export const CardBodyHeaderTitle = ({ className, ...props }: CardProps) => (
  <div className={cn(`items-center truncate p-4 pt-2.5 pb-2.5`, className)} {...props} />
)

export const CardBodyContent = ({ className, testId, ...props }: CardProps & CardBodyContentProps) => (
  <div
    className={cn(`text-on-surface-subdued flex items-start p-4 pt-0 text-sm leading-5 font-normal`, className)}
    {...props}
    data-testid={testId && `${testId}-card-body-content`}
  />
)

export const CardFooter = ({ className, ...props }: CardProps) => (
  <div className={cn("flex shrink-0 items-center justify-end gap-2 self-stretch p-4 pt-2", className)} {...props} />
)
